import { WebsiteHeaderPhotoSchema_PhotoMarquee_v1_1_1 } from '@apps/guest/websiteHeader';

export const PHOTO_MARQUEE_v1_1_1: WebsiteHeaderPhotoSchema_PhotoMarquee_v1_1_1 = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoMarquee-v1_1_1.json',
  presentationLayout: 'photoMarquee',
  photos: [],
};
